var spSearch = {
	init: function(){
		console.log("search page")
	},
	hideResult: function(){
		let $body = $("body");
		//検索結果が出ていたら消す
		if( $("#search_layer_spot").hasClass("show") ){
			$("#search_layer_spot").removeClass("show");
			$body.removeClass("scroll_spot");
		}
		if( $("#search_layer_deck").hasClass("show") ){
			$("#search_layer_deck").removeClass("show");
			$body.removeClass("scroll_deck");
		}
	},
	showSpotResultPage: function(){
		let $body = $("body");
		common.scrollToPosition(0, 50);
		if( !$body.hasClass("scroll_spot") ){
			$("#search_layer_spot").addClass("show");
			setTimeout(function(){
				$body.addClass("scroll_spot");
			},600);
		}
	},
	showDeckResultPage: function(){
		let $body = $("body");

		if( !$body.hasClass("scroll_deck") ){
			$("#search_layer_deck").addClass("show");
			setTimeout(function(){
				common.scrollToPosition(0, 50);
				$("#search_layer_deck").removeClass("disable");
				setTimeout(function(){
					$body.addClass("scroll_deck");
				}, 300);
			}, 400);
			
		}
	}
}